import content from "./content/trading-platforms.json";

export const tradingPlatformsMock = {
  name: "trading-platforms",
  layoutType: 1,
  areasList: [
    {
      id: "trading-platforms-main",
      componentName: "Comp:TradingPlatformsPage",
      content: JSON.stringify(content),
    },
  ],
};
